import { PageBody } from "../../components/pageBody/PageBody"
import { useContext, useEffect } from "react"
import { BackButtonContext } from "../../context/BackButtonContext"
import { useNhsAppJs } from "../../hooks/useNhsAppJs"

type LoggedOutProps = {
  userIsLoggedOut: boolean
  userIsTimedOut: boolean
}

export const LoggedOut = ({ userIsLoggedOut, userIsTimedOut }: LoggedOutProps) => {
  const { setShowBackButton } = useContext(BackButtonContext)
  const { inApp, navigateToPage } = useNhsAppJs()

  useEffect(() => {
    if (inApp) {
      navigateToPage("home")
    }
  }, [inApp, navigateToPage])

  useEffect(() => {
    if (!setShowBackButton) return
    setShowBackButton(false)
  }, [setShowBackButton])

  useEffect(() => {
    document.title = userIsLoggedOut ? "You have logged out" : "You have been logged out"
  }, [userIsLoggedOut])

  return (
    <>
      <PageBody>
        <h1 className="block-header">{userIsLoggedOut ? "You have logged out" : "You have been logged out"}</h1>
        {userIsTimedOut && (
          <p>For security reasons, you’re automatically logged out if you have not used the service for 10 minutes.</p>
        )}
        <p>If you were entering information, it has not been saved and you will need to re-enter it.</p>
        <p>To continue, close the tab which has the service open and log in again.</p>
      </PageBody>
    </>
  )
}
